import React from "react";
import Profile from "../ui/Dashboard";

function StudentProfile(props) {
  return (
    <div className="containerVertical">
      <Profile title="Your Profile" />
    </div>
  );
}

export default StudentProfile;
